import * as React from 'react';
import { useFullscreenModal } from '../../../../models/hooks/appStateHooks';

/**
 * Back arrow behavior for the texting campaign composer screens. Returning nothing lets the fullscreen
 * modal's own handler step back through its history; on the first screen there is nothing in-modal to
 * return to, so the arrow closes the modal rather than sitting there inert.
 */
export function useComposerBackHandler() {
	const fullscreenModal = useFullscreenModal();
	return (ev: React.MouseEvent<HTMLElement>) => {
		if (fullscreenModal.history.canGoBackWithinTrackedHistory) {
			return;
		}
		ev.preventDefault();
		fullscreenModal.dismissModal();
	};
}
